import { type Theme, useMediaQuery } from "@mui/material";

export function useShowSidebar(): boolean {
  return useMediaQuery((x: Theme) => x.breakpoints.up("lg"), { noSsr: true });
}
